import { ReactNode } from 'react';
import ReportPreviewPageFooter from 'app/modules/analytics/modules/reports/components/reportPreview/ReportPreviewPageFooter';
import {
  getReportPreviewPageShellClassName,
  getReportPreviewExportPageStyle,
  type ReportPreviewLayout,
} from 'app/modules/analytics/modules/reports/constants/reportPreviewPageShellClassName';
import ViewReportPreviewPageHeader from './ViewReportPreviewPageHeader';

interface Props {
  profileLabel: string;
  profileLogoSrc?: string;
  profilePageType?: number;
  reportName: string;
  since: string;
  until: string;
  pageNumber: number;
  totalPages: number;
  layout?: ReportPreviewLayout;
  breakBeforeFirstPage?: boolean;
  children: ReactNode;
}

const ViewReportPreviewPageShell = ({
  profileLabel,
  profileLogoSrc,
  profilePageType,
  reportName,
  since,
  until,
  pageNumber,
  totalPages,
  layout = 'modal',
  breakBeforeFirstPage = false,
  children,
}: Props) => {
  return (
    <article
      className={getReportPreviewPageShellClassName(layout)}
      data-cy={`analytics_view-report_preview-page-${pageNumber}`}
      style={
        layout === 'export'
          ? getReportPreviewExportPageStyle(
              pageNumber,
              totalPages,
              breakBeforeFirstPage,
            )
          : undefined
      }
    >
      <ViewReportPreviewPageHeader
        profileLabel={profileLabel}
        profileLogoSrc={profileLogoSrc}
        profilePageType={profilePageType}
        reportName={reportName}
        since={since}
        until={until}
        layout={layout}
      />
      <div className="tw-mt-6 tw-flex tw-flex-1 tw-flex-col">{children}</div>
      {totalPages > 0 ? (
        <ReportPreviewPageFooter
          pageNumber={pageNumber}
          totalPages={totalPages}
        />
      ) : null}
    </article>
  );
};

export default ViewReportPreviewPageShell;
